import { Heading, type HeadingProps } from '@frontend/legacy-components';

export type ResponseHeadingProps = HeadingProps & {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const sizeMap = {
  h1: 'xl',
  h2: 'lg',
  h3: 'md',
  h4: 'md',
  h5: 'md',
  h6: 'md',
} as const;

/**
 * Base heading component for Response.
 * Provides consistent styling for headings in AI responses.
 */
export const ResponseHeading = ({
  as,
  className,
  children,
  ...props
}: ResponseHeadingProps) => {
  return (
    <Heading as={as} size={sizeMap[as]} mt={1} className={className} {...props}>
      {children}
    </Heading>
  );
};
